import { observer } from 'mobx-react';
import React from "react";
import './task-list.css';
import FilterPanel from "./filter-panel";
import TaskTable from './task-table';
import Subjects from '../../models/subjects';

const TaskList: React.FC<{subject: Subjects}> = ({subject}) => {

    return (
        <div className="content">
            <FilterPanel subject={subject} />
            <TaskTable subject={subject} />
        </div>
    );
};

export default observer(TaskList);